import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '../utilities/utilities.module';
import { TagViewComponent } from './tag-view/tag-view.component';
import { TagListComponent } from './tag-list/tag-list.component';
import { ComponentsModule } from '../components/components.module';
import { TagService } from './tag.service';
import { TagEditComponent } from './tag-edit/tag-edit.component';
import { FormsModule } from '@angular/forms';
import { TagDialogProcessUntagComponent } from './tag-dialog-process-untag/tag-dialog-process-untag.component';
import { UIRouterModule } from '@uirouter/angular';
import { TagStates } from '@fi-app/tag/tag-states';
import { FiTagModuleTypeNamesComponent } from '@fi-app/tag/tag-module-type-names/tag-module-type-names.component';
import { FiTagListColumnModuleNamesComponent } from '@fi-app/tag/tag-list/column-module-names/column-module-names.component';
import { MatTabsModule } from '@angular/material/tabs';
import { DocumentModule } from '@fi-app/document/document.module';
import { MediaBankModule } from '@fi-app/media-bank/media-bank.module';
import { ChecklistListModule } from '@fi-app/checklist/list/checklist-list.module';
import { UserModule } from '@fi-app/user/user.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatCardModule } from '@angular/material/card';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { TagListTableContainerComponent } from './tag-list/tag-list-table-container/tag-list-table-container.component';
import { MatIconModule } from '@angular/material/icon';
import { FiTagHelperService } from './fi-tag-helper.service';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        UtilitiesModule,
        FormsModule,
        UIRouterModule.forChild(TagStates),
        MatTabsModule,
        DocumentModule,
        MediaBankModule,
        ChecklistListModule,
        UserModule,
        FiItemsListModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatCardModule,
        SelectSearchModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatIconModule,
    ],
    declarations: [
        TagViewComponent,
        TagListComponent,
        TagEditComponent,
        TagDialogProcessUntagComponent,
        FiTagModuleTypeNamesComponent,
        FiTagListColumnModuleNamesComponent,
        TagListTableContainerComponent,
    ],
    providers: [TagService, FiTagHelperService],
})
export class TagModule {}
